module.exports = __webpack_public_path__ + "static/helvetica-neue-bold-4622c9999e38ce864c1553f4b79830d5.woff2";